export const DEFAULT_GUTTER_WIDTH_DESKTOP = 32;
export const DEFAULT_GUTTER_WIDTH_MOBILE = 16;
export const DEFAULT_PAGE_TOP_OFFSET_DESKTOP = 16;
export const DEFAULT_PAGE_TOP_OFFSET_MOBILE= 16;
export const DEFAULT_PAGE_BOTTOM_OFFSET_DESKTOP = 16;
export const DEFAULT_PAGE_BOTTOM_OFFSET_MOBILE= 16;
export const MOBILE_HEADER_HEIGHT = 60;
export const SIDEBAR_EXPANDED_WIDTH = 240;
export const SIDEBAR_COLLAPSED_WIDTH = 100;
export const SORT_KEY_DELIMITER = ':';